import { RouterConfig } from "@shared/lib/routerConfig";
import { productErrorTexts } from "./constants";
import classes from "./product-error.module.scss";

export const ProductError = () => {
    return (
        <div className={classes["product-error"]}>
            <h1 className={classes["product-error__title"]}>{productErrorTexts.TITLE}</h1>
            <p className={classes["product-error__text"]}>{productErrorTexts.DESCRIPTION}</p>
            <p className={classes["product-error__text"]}>{productErrorTexts.DESCRIPTION_ACTION}</p>
            <p className={classes["product-error__text"]}>
                {productErrorTexts.ACTION}{" "}
                <a className={classes["product-error__link"]} href={RouterConfig.MAIN}>
                    главную страницу
                </a>{" "}
                или на{" "}
                <a className={classes["product-error__link"]} href={RouterConfig.CATALOG}>
                    страницу объявлений
                </a>
                .
            </p>
        </div>
    );
};